import { Flex } from '@chakra-ui/react';
import { Avatar, AvatarImage, Icon, Person as PersonIcon } from '@mesh.ai/rabbit';

import { TextHeader4, TextLabel } from 'uiToolkitV1/Typography';

interface AgendaItemProps {
  title: string;
  ownerName: string;
  ownerProfilePic?: string;
}

export const AgendaItem = ({ title, ownerName, ownerProfilePic }: AgendaItemProps) => (
  <Flex flexDirection="column" p="8px 12px" gap="8px" borderBottom="1px solid #EBEFF3">
    <TextHeader4 bold>{title}</TextHeader4>
    <Flex gap="4px" alignItems="center">
      <TextLabel>Added by</TextLabel>
      {ownerProfilePic ? (
        <Avatar size="xs">
          <AvatarImage src={ownerProfilePic} />
        </Avatar>
      ) : (
        <Icon IconSVG={PersonIcon} size="x-small" />
      )}
      <TextLabel>{ownerName}</TextLabel>
      <TextLabel>•</TextLabel>
      <Flex
        justifyContent="center"
        alignItems="center"
        borderRadius="4px"
        bg="#DBF2D3"
        boxShadow="0px 0px 1px 0px rgba(0, 0, 0, 0.25)"
        p="0px 4px"
      >
        <TextLabel textAlign="center" color="#44812F">
          1:1
        </TextLabel>
      </Flex>
    </Flex>
  </Flex>
);
